import { useQuery } from '@apollo/client'
import { useMemo } from 'react'
import { useCurrentAccountContext } from '@retailer-platform/dashboard/utils'
import { clientEnv } from '@retailer-platform/dashboard/env'
import { GetQualityScorecardsAggScorecardsDocument } from './index'
import {
  type GetQualityScorecardsAggScorecardsQuery,
  type GetQualityScorecardsAggScorecardsQueryVariables,
} from './index'

interface UseQualityScorecardsDataParams {
  ippTotemEntity?: string
  team?: string
  limit?: number
  offset?: number
  orderBy?: string
  orderDirection?: string
}

export const useQualityScorecardsData = (params: UseQualityScorecardsDataParams) => {
  const { account } = useCurrentAccountContext()
  const isInternal = account?.isInternal
  // Quality Scorecards data is only available and accessible in production.
  // Skip query if not in production or local environment or not internal user
  const shouldSkip =
    !(
      clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'production' ||
      clientEnv.PUBLIC_CLIENT_ENVIRONMENT === 'local'
    ) || !isInternal

  const { data, loading, error, refetch } = useQuery<
    GetQualityScorecardsAggScorecardsQuery,
    GetQualityScorecardsAggScorecardsQueryVariables
  >(GetQualityScorecardsAggScorecardsDocument, {
    variables: {
      ippTotemEntity: params.ippTotemEntity || undefined,
      team: params.team || undefined,
      limit: params.limit || 150,
      offset: params.offset || 0,
      orderBy: params.orderBy || 'ipp_totem_entity',
      orderDirection: params.orderDirection || 'asc',
    },
    skip: shouldSkip,
  })

  const scorecards = useMemo(() => data?.qualityScorecardsAggScorecards?.scorecards || [], [data])

  const totalCount = useMemo(() => data?.qualityScorecardsAggScorecards?.totalCount || 0, [data])

  return {
    scorecards,
    totalCount,
    loading,
    error,
    refetch,
  }
}
